module.exports = __webpack_public_path__ + "img/main-tablet.1ad312c3.webp";